import { useEffect, useState } from 'react';

const useMediaQuery = (...queries: string[]): boolean => {
  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  const [match, setMatch] = useState(false);

  const query = queries.join();

  useEffect(() => {
    let active = true;
    if (!supportMatchMedia) return undefined;

    const queryList = window.matchMedia(query);

    function updateMatch() {
      if (active) setMatch(queryList.matches);
    }

    updateMatch();
    queryList.addEventListener('change', updateMatch);

    return () => {
      active = false;
      queryList.removeEventListener('change', updateMatch);
    };
  }, [query, supportMatchMedia]);

  return match;
};

export const useViewport = () => {
  const isMediumDesktop = useMediaQuery('screen and (max-width: 1920px)');
  const isBigDesktop = useMediaQuery('screen and (min-width: 2560px)');

  return {
    isMediumDesktop,
    isBigDesktop,
  };
};
